import { useEffect, useState } from "react";
import { History, ArrowRight } from "lucide-react";
import { api } from "@/lib/api";
import { fmtUF } from "@/lib/useFees";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";

const KIND = { publication: "Publicación", commission: "Reserva" };
const when = (iso) => new Date(iso).toLocaleString("es-CL", { timeZone: "America/Santiago", day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit", hour12: false });

export const FeeHistory = ({ version }) => {
  const [rows, setRows] = useState(null);
  useEffect(() => { api.get("/admin/settings/fee-history").then((r) => setRows(r.data)).catch(() => setRows([])); }, [version]);
  return (
    <Card className="p-6 space-y-4 mt-6" data-testid="fee-history-card">
      <div className="flex items-center gap-2"><History className="w-5 h-5 text-primary" /><h3 className="font-bold">Historial de tarifas</h3></div>
      <p className="text-sm text-muted-foreground">Cada cambio de la tarifa base de publicación, con su fecha y valor anterior.</p>
      {rows === null ? null : rows.length === 0 ? (
        <p className="text-sm text-muted-foreground py-2" data-testid="fee-history-empty">Aún no hay cambios registrados.</p>
      ) : (
        <ul className="divide-y max-h-80 overflow-y-auto -mx-2 px-2" data-testid="fee-history-list">
          {rows.map((r) => (
            <li key={r.id} className="py-3 flex flex-wrap items-center gap-x-3 gap-y-1 text-sm" data-testid={`fee-history-row-${r.id}`}>
              <span className="text-xs text-muted-foreground w-36 shrink-0">{when(r.changed_at)}</span>
              <Badge variant="outline" className={r.kind === "commission" ? "border-primary/40 text-primary" : ""}>{KIND[r.kind]}</Badge>
              <span className="inline-flex items-center gap-1.5 font-medium">
                <span className="text-muted-foreground line-through">{fmtUF(r.old_uf)} UF</span>
                <ArrowRight className="w-3.5 h-3.5 text-muted-foreground" />{fmtUF(r.new_uf)} UF
              </span>
              {r.changed_by && <span className="text-xs text-muted-foreground sm:ml-auto truncate">{r.changed_by}</span>}
            </li>
          ))}
        </ul>
      )}
    </Card>
  );
};
